import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db } from '../firebaseConfig';
import { doc, onSnapshot } from 'firebase/firestore';
import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';
// eslint-disable-next-line no-unused-vars
import { IoArrowBack, IoMap } from 'react-icons/io5';
import './SeguridadScreen.css'; // Reusing some base styles

// eslint-disable-next-line no-unused-vars
const mapContainerStyle = {
    width: '100%',
    height: 'calc(100vh - 80px)', // Adjust based on header
};

function ResidentesLiveMap() {
    const { vigilanteId } = useParams();
    const navigate = useNavigate();
    const [vigilanteData, setVigilanteData] = useState(null);
    const [loading, setLoading] = useState(true);

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY,
    });

    useEffect(() => {
        if (!vigilanteId) return;

        // Suscribirse a la ubicación en vivo del vigilante
        const vigilanteRef = doc(db, 'usuarios', vigilanteId);
        const unsubscribe = onSnapshot(vigilanteRef, (docSnap) => {
            if (docSnap.exists()) {
                const data = docSnap.data();
                setVigilanteData(data);

                // Si inesperadamente deja de estar en rondín, regresar o avisar
                if (data.liveLocation && !data.liveLocation.inRondin) {
                    alert("El vigilante ha finalizado el rondín.");
                    navigate('/seguridad/vigilantes');
                }
            }
            setLoading(false);
        });

        return () => unsubscribe();
    }, [vigilanteId, navigate]);

    if (!isLoaded || loading) return <div style={{ textAlign: 'center', marginTop: '50px' }}>Cargando Mapa...</div>;

    const currentLocation = vigilanteData?.liveLocation;
    const center = currentLocation ? { lat: currentLocation.lat, lng: currentLocation.lng } : { lat: 19.4326, lng: -99.1332 };

    return (
        <div style={{ position: 'relative', height: '100vh', display: 'flex', flexDirection: 'column' }}>
            {/* Simple Header Reused */}
            <div className="seguridad-fixed-wrapper" style={{ paddingBottom: '10px' }}>
                <div className="seguridad-banner-compact" style={{ margin: '0 10px' }}>
                    <button onClick={() => navigate(-1)} className="seguridad-back-btn glass">
                        <IoArrowBack size={24} />
                    </button>
                    <div className="seguridad-banner-content">
                        <h2>{vigilanteData?.nombre || 'Vigilante'}</h2>
                        <p>Ubicación en vivo</p>
                    </div>
                </div>
            </div>

            {/* Map Area */}
            <div style={{ flex: 1, position: 'relative' }}>
                <GoogleMap
                    mapContainerStyle={{ width: '100%', height: '100%' }}
                    center={center}
                    zoom={18}
                    options={{
                        disableDefaultUI: true,
                        zoomControl: true,
                    }}
                >
                    {currentLocation && (
                        <Marker
                            position={{ lat: currentLocation.lat, lng: currentLocation.lng }}
                            icon={{
                                url: 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png'
                            }}
                        />
                    )}
                </GoogleMap>
            </div>
        </div>
    );
}

export default ResidentesLiveMap;
